/**
 * en-GB messages added by Phase 4 task W30 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w30EnGB = {
    // Forms admin list
    'w30.forms.title': 'Pre-registration forms',
    'w30.forms.description': 'Public forms where visitors book their own visit. Share the link on your website or in an email.',
    'w30.forms.new': 'New form',
    'w30.forms.search': 'Search forms',
    'w30.forms.siteFilter': 'Site',
    'w30.forms.allSites': 'All sites',
    'w30.forms.statusFilter': 'Status',
    'w30.forms.status.all': 'All',
    'w30.forms.status.on': 'Open',
    'w30.forms.status.off': 'Closed',
    'w30.forms.sort': 'Sort by',
    'w30.forms.sort.name': 'Name',
    'w30.forms.sort.submissions': 'Submissions',
    'w30.forms.table': 'Pre-registration forms',
    'w30.forms.col.name': 'Name',
    'w30.forms.col.site': 'Site and group',
    'w30.forms.col.status': 'Status',
    'w30.forms.col.submissions': 'Submissions (30 days)',
    'w30.forms.col.actions': 'Actions',
    'w30.forms.badge.on': 'Open',
    'w30.forms.badge.off': 'Closed',
    'w30.forms.badge.approval': 'Needs approval',
    'w30.forms.empty': 'No forms yet. Create one so visitors can book their own visit.',
    'w30.forms.loadError': 'The forms could not be loaded.',
    'w30.forms.copyLink': 'Copy link',
    'w30.forms.copyLinkFor': 'Copy the public link for {name}',
    'w30.forms.copied': 'Link copied.',
    'w30.forms.copyFailed': 'The link could not be copied. Select it and copy it by hand.',
    'w30.forms.edit': 'Edit',
    'w30.forms.editFor': 'Edit {name}',
    'w30.forms.delete': 'Delete',
    'w30.forms.deleteFor': 'Delete {name}',
    'w30.forms.deleted': 'Form deleted. Earlier submissions are kept.',
    'w30.forms.saved': 'Form saved.',
    'w30.forms.created': 'Form created.',
    'w30.forms.link': 'Public link',
    // Form editor
    'w30.form.createTitle': 'New form',
    'w30.form.editTitle': 'Edit form',
    'w30.form.name': 'Name',
    'w30.form.nameHint': 'Shown only to your team, for example "Visitor booking".',
    'w30.form.slug': 'Web address name',
    'w30.form.slugHint': 'Lower-case letters, numbers and hyphens. It forms the end of the public link.',
    'w30.form.slugInvalid': 'Use 2 to 40 lower-case letters, numbers or hyphens, not starting or ending with a hyphen.',
    'w30.form.site': 'Site',
    'w30.form.group': 'Group',
    'w30.form.groupHint': 'The group the visitor will sign in as.',
    'w30.form.choose': 'Choose…',
    'w30.form.enabled': 'Form is open',
    'w30.form.enabledHint': 'When closed, the public link shows a "not found" page.',
    'w30.form.requireApproval': 'Submissions need approval',
    'w30.form.requireApprovalHint': 'A member of staff approves each booking before the visitor gets their confirmation email.',
    'w30.form.maxDaysAhead': 'How far ahead visitors can book (days)',
    'w30.form.intro': 'Introduction',
    'w30.form.introHint': 'Shown at the top of the form.',
    'w30.form.thanks': 'Thank-you message',
    'w30.form.thanksHint': 'Shown after the visitor sends the form.',
    'w30.form.consentText': 'Consent text',
    'w30.form.consentTextHint': 'If you add text here, visitors must tick a box to agree before they send the form.',
    'w30.form.fieldsLegend': 'What the form asks for',
    'w30.form.fieldsHint': "The visitor's name and the date and time are always asked.",
    'w30.form.field.email': 'Email address',
    'w30.form.field.phone': 'Phone number',
    'w30.form.field.company': 'Company',
    'w30.form.field.host': 'Who they are visiting',
    'w30.form.hostHint': "The visitor types a name. It is only matched when exactly one current member has that name. Staff names are never listed on the form.",
    'w30.form.mode.off': 'Not asked',
    'w30.form.mode.none': 'Not asked',
    'w30.form.mode.optional': 'Optional',
    'w30.form.mode.required': 'Required',
    'w30.form.questions': 'Questions to ask in advance',
    'w30.form.questionsHint': 'Sign-in questions for this site and group. Sensitive questions can never be asked on a public form, so they are not listed.',
    'w30.form.questionsNone': 'There are no questions you can ask in advance for this site and group.',
    'w30.form.save': 'Save form',
    'w30.form.create': 'Create form',
    'w30.form.needSiteGroup': 'Choose a site and a group.',
    // Outlook add-in: common
    'w30.outlook.title': 'CloudSign for Outlook',
    'w30.outlook.intro': 'Pre-register the guests of this meeting. They get an email with their QR code, and you are their host.',
    'w30.outlook.loading': 'Loading…',
    'w30.outlook.notOutlook': 'Open this page from the CloudSign add-in in Outlook.',
    'w30.outlook.noMeeting': 'Open or save a meeting first, then use the add-in.',
    'w30.outlook.saveFirst': 'Save the meeting first so it can be matched later, then try again.',
    'w30.outlook.readError': 'The meeting details could not be read.',
    'w30.outlook.connect': 'Connect to CloudSign',
    'w30.outlook.connecting': 'Waiting for the sign-in window…',
    'w30.outlook.connectFailed': 'Outlook could not be connected. Please try again.',
    'w30.outlook.connectCancelled': 'The sign-in window was closed before it finished.',
    'w30.outlook.disconnect': 'Disconnect',
    'w30.outlook.sessionExpired': 'Your connection has ended. Connect again to carry on.',
    'w30.outlook.notConnected': 'Connect Outlook to your CloudSign account to pre-register guests.',
    // Connect page
    'w30.connect.title': 'Connect Outlook',
    'w30.connect.description': 'This lets the CloudSign add-in in Outlook pre-register guests for you. You can disconnect it at any time from your account page.',
    'w30.connect.label': 'Outlook add-in',
    'w30.connect.allow': 'Allow Outlook to use my account',
    'w30.connect.allowHint': 'The add-in can only pre-register and cancel guests for meetings. It cannot open any other part of CloudSign.',
    'w30.connect.done': 'Connected. You can close this window.',
    'w30.connect.error': 'The connection could not be created.',
    // Task pane
    'w30.pane.meeting': 'Meeting',
    'w30.pane.subject': 'Subject',
    'w30.pane.when': 'When',
    'w30.pane.noSubject': '(no subject)',
    'w30.pane.site': 'Site',
    'w30.pane.group': 'Group',
    'w30.pane.choose': 'Choose…',
    'w30.pane.guests': 'Guests',
    'w30.pane.guestsNone': 'This meeting has no guests yet.',
    'w30.pane.guestsHint': 'Colleagues and other staff are skipped automatically.',
    'w30.pane.sendEmail': 'Email the guests their invitation',
    'w30.pane.noHost': 'No staff record matches your email address, so the visit will have no host. Ask an administrator to add you as a member.',
    'w30.pane.preRegister': 'Pre-register guests',
    'w30.pane.update': 'Update visitors',
    'w30.pane.cancel': 'Cancel visitors',
    'w30.pane.working': 'Working…',
    'w30.pane.resultCreated': 'Pre-registered: {count}',
    'w30.pane.resultUpdated': 'Updated: {count}',
    'w30.pane.resultCancelled': 'Cancelled: {count}',
    'w30.pane.resultSkipped': 'Skipped:',
    'w30.pane.skip.internal': 'colleague or staff member',
    'w30.pane.skip.other': 'not pre-registered',
    'w30.pane.noSites': 'You cannot pre-register into any site. Ask an administrator for access.',
};
//# sourceMappingURL=w30.js.map